import React from 'react';
import { Helmet } from 'react-helmet-async';
import Layout from './Layout';
import Hero from './Hero';
import HomeSections from './HomeSections';

const HomePage = () => {
  return (
    <Layout>
      <Helmet defer={false}>
        <title>Free Local Google SERP Checker - No VPN, No Signup</title>
        <meta name="description" content="Open the real Google results page localized to any country or city. Free local SERP checker: no VPN, no proxy, no signup. Built for SEO work." />
        <link rel="canonical" href="https://freeserpchecker.org/" />
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://freeserpchecker.org/" />
        <meta property="og:title" content="Free Local Google SERP Checker - No VPN, No Signup" />
        <meta property="og:description" content="Open the real Google results page localized to any country or city. Free local SERP checker: no VPN, no proxy, no signup. Built for SEO work." />
        <meta property="og:image" content="https://freeserpchecker.org/og-image.png" />
        
        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://freeserpchecker.org/" />
        <meta property="twitter:title" content="Free Local Google SERP Checker - No VPN, No Signup" />
        <meta property="twitter:description" content="Open the real Google results page localized to any country or city. Free local SERP checker: no VPN, no proxy, no signup. Built for SEO work." />
        <meta property="twitter:image" content="https://freeserpchecker.org/og-image.png" />
        
      </Helmet>
      
      <Hero />
      <HomeSections />
    </Layout>
  );
};

export default HomePage;
